module.exports = __webpack_public_path__ + "static/img/bg-zz.2505b3d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/bg-zz.png
// module id = cSiM
// module chunks = 1